import { Mode, Skin } from '@webbyx/mui';

import {
  error,
  errorBg,
  info,
  infoBg,
  success,
  successBg,
  warning,
  warningBg,
} from '../../config/colors';

/**
 * ===========================
 * MAIN
 * ===========================
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createThemeOverrideChip = (mode: Mode, skin: Skin) => {
  const defaultSettings = {
    fontSize: '0.75rem',
    fontWeight: 500,
  };
  return {
    MuiChip: {
      defaultProps: {
        size: 'small' as any,
      },
      variants: [
        {
          props: { color: 'info' as any },
          style: {
            ...defaultSettings,
            color: info,
            background: infoBg,
          },
        },
        {
          props: { color: 'success' as any },
          style: {
            ...defaultSettings,
            color: success,
            backgroundColor: successBg,
          },
        },
        {
          props: { color: 'warning' as any },
          style: {
            ...defaultSettings,
            color: warning,
            backgroundColor: warningBg,
          },
        },
        {
          props: { color: 'error' as any },
          style: {
            ...defaultSettings,
            color: error,
            backgroundColor: errorBg,
          },
        },
        {
          props: { variant: 'outlined' as any },
          style: {
            backgroundColor: 'transparent',
          },
        },
      ],
      styleOverrides: {
        root: {
          width: 'fit-content',
          '&.MuiChip-rounded': {
            borderRadius: 4,
          },
          ...defaultSettings,
        },
        // outlined: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-colorDefault': {
        //     borderColor: `rgba(${theme.palette.customColors.main}, 0.22)`,
        //   },
        // }),
        // avatar: ({ theme }: OwnerStateThemeType) => ({
        //   color: theme.palette.text.primary,
        // }),
        // deletableColorPrimary: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-light .MuiChip-deleteIcon': {
        //     color: hexToRGBA(theme.palette.primary.main, 0.7),
        //     '&:hover': {
        //       color: theme.palette.primary.main,
        //     },
        //   },
        // }),
        // deletableColorSecondary: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-light .MuiChip-deleteIcon': {
        //     color: hexToRGBA(theme.palette.secondary.main, 0.7),
        //     '&:hover': {
        //       color: theme.palette.secondary.main,
        //     },
        //   },
        // }),
        // deletableColorSuccess: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-light .MuiChip-deleteIcon': {
        //     color: hexToRGBA(theme.palette.success.main, 0.7),
        //     '&:hover': {
        //       color: theme.palette.success.main,
        //     },
        //   },
        // }),
        // deletableColorError: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-light .MuiChip-deleteIcon': {
        //     color: hexToRGBA(theme.palette.error.main, 0.7),
        //     '&:hover': {
        //       color: theme.palette.error.main,
        //     },
        //   },
        // }),
        // deletableColorWarning: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-light .MuiChip-deleteIcon': {
        //     color: hexToRGBA(theme.palette.warning.main, 0.7),
        //     '&:hover': {
        //       color: theme.palette.warning.main,
        //     },
        //   },
        // }),
        // deletableColorInfo: ({ theme }: OwnerStateThemeType) => ({
        //   '&.MuiChip-light .MuiChip-deleteIcon': {
        //     color: hexToRGBA(theme.palette.info.main, 0.7),
        //     '&:hover': {
        //       color: theme.palette.info.main,
        //     },
        //   },
        // }),
      },
    },
  };
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default createThemeOverrideChip;
